import type { Route } from '!/router'

import * as auth from './auth'
import * as error from './error'
import * as not_found from './not-found'
// import * as privacy_policy from './privacy-policy'
// import * as profiles from './profiles'
// import * as toa from './toa'

export const before: Route[] = [
  // service route to show navigation error
  // cound be happen, for example, when action throw an exception
  // should be first, so router resolve will not fail _before_ reach this route
  {
    path: '/error',
    load: error.route,
  },
]

export const route: Route = {
  children: [
    {
      path: '',
      load: auth.route,
    },
    {
      path: '/player',
      load: () => import('./player').then((m) => m.route),
    },
    {
      path: '/terms-of-agreements',
      load: () => import('./toa').then((m) => m.route),
    },
    {
      path: '/privacy-policy',
      load: () => import('./privacy-policy').then((m) => m.route),
    },
    {
      path: '/profiles',
      load: () => import('./profiles').then((m) => m.route),
    },
  ],
}

export const after: Route[] = [
  // not found case,
  // must be the last one
  {
    path: '{/*path}',
    load: not_found.route,
  },
]
